
<!-- MEASUREMENT TYPE - TEMPERATURE -->

<!-- MEASUREMENT INFORMATION CARD -->
@if (measurement(); as m) {
  <cosmos-measurement-info-card
    [measurement]="m"
    [device]="device()"
    [cardSubtitle]="('measurement.types.TemperatureMeasurement' | translate) + ' - ' + ((m.active ? 'measurement.ongoing' : 'measurement.finished') | translate)"
  >
    <ng-container cardFooter>
      <p-confirmdialog />
      <div class="flex flex-wrap gap-2 items-center">
        @if (rbac.canEditProject()) {
          <p-button (click)="editMeasurement()" color="primary"><i class="fa-solid fa-edit"></i> {{ "measurement.edit" | translate }}</p-button>
        }
        @if (m.active && rbac.canEditProject()) {
          <div id="onboarding-measurement-finish">
            <p-button (click)="finishMeasurement($event)" severity="danger"><i class="fa-solid fa-link-slash"></i>{{ "measurement.finish" | translate }}</p-button>
          </div>
        }
        @if (m.active && rbac.canEditProject()) {
          <div id="onboarding-measurement-change-device">
            <p-button (click)="changeDevice(m)" severity="secondary"><i class="fa-solid fa-shuffle"></i>{{ "measurement.change_device" | translate }}</p-button>
          </div>
        }
        @if (rbac.canEditProject()) {
          <div id="onboarding-measurement-actions-menu">
            <cosmos-measurement-actions-menu [actions]="tier2Actions()" />
          </div>
        }
      </div>
    </ng-container>
  </cosmos-measurement-info-card>
}

<p-divider></p-divider>

<!--CHARTS-->
@if (measurement(); as m) {
  <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
    <cosmos-temperature-insights-card
      id="onboarding-temperature-insights"
      [temperatures]="m.temperature?.length ? m.temperature : undefined"
      [specifications_temperature]="m.specifications ?? []"
      [time]="m.time?.length ? m.time[m.time.length - 1] : undefined"
    >
    </cosmos-temperature-insights-card>
    <!-- right side -->
    <div class="col-span-2 grid gap-4 min-w-0">
      <p-card id="onboarding-temperature-chart" class="min-w-0">
        <ng-template #title>{{ "measurement.chart.temperature.title" | translate }}</ng-template>
        <ng-template #subtitle>{{ "measurement.chart.subtitle" | translate }}</ng-template>
        <!-- content -->
        <cosmos-dynamic-line-chart
          [dataObject]="m"
          [datasets]="['temperature']"
          [labels]="['temperature']"
          [thresholds]="{}"
          [chartId]="'temperature_measurement'">
        </cosmos-dynamic-line-chart>
      </p-card>
    </div>
  </div>
}
